import React from "react";

const ProjectsCard = ({ title, des, src, tags = [] }) => {
  return (
    <div className="w-full h-[380px] rounded-lg overflow-hidden bg-[#1A1025] border-[1px] border-[#4B006E] hover:shadow-[0_0_15px_rgba(138,0,212,0.3)] transition-all duration-300 ease-[cubic-bezier(0.25,0.8,0.25,1)] flex flex-col">
      {/* Image container at the top with fixed height */}
      <div className="w-full h-[180px] bg-gray-700 overflow-hidden flex items-center justify-center">
        {src ? (
          <img
            className="w-full h-full object-cover object-center"
            src={src}
            alt={title}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-[#150c1c]">
            <div className="text-lightText text-base">Project Image</div>
          </div>
        )}
      </div>

      {/* Text content below with padding */}
      <div className="p-10 flex flex-col flex-grow">
        <h3 className="font-display font-bold text-2xl text-[#8A00D4] mb-4">
          {title}
        </h3>
        <p className="font-sans font-normal text-base text-lightText leading-relaxed mb-4">
          {des}
        </p>

        {/* Tags */}
        {tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-auto">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="px-3 py-1 font-sans font-normal text-xs bg-[#0A0A14] text-lightText rounded-md hover:bg-[#4B006E] transition-all duration-300"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectsCard;
